import { useLocation, useNavigate } from "react-router-dom";
import { Item } from "@models/item";
import { DocumentItemAdd } from "@models/document-item";
import { editLastBread, getLastAvailableLink } from "../../../utils/breadcrumbs";
import { ITEMS_BREADCRUMB, ITEMS_PATH, ITEMS_STRUCTURE_CRUMBS } from "./items.constants";

export function useItemsNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  function buildBreadcrumb(state: unknown) {
    const base = [
      { name: ITEMS_BREADCRUMB.ledger },
      { name: ITEMS_BREADCRUMB.list, link: ITEMS_PATH },
    ];
    const stateRecord = state as { breadcrumbData?: { name: string; link?: string }[] } | null | undefined;
    return [...(editLastBread(stateRecord?.breadcrumbData, ITEMS_PATH, state) ?? base)];
  }

  function rowChosen(row: Item): void {
    if (!location.state?.breadcrumbData) {
      return;
    }

    const updatedItems: DocumentItemAdd[] = [...location.state.items];
    updatedItems[location.state.itemRowIndex] = {
      ...row,
      item_id: row.id,
      amount: 1,
      discount: 0,
      price: row.price ?? 0,
      net: row.price ?? 0,
      total: row.price ?? 0,
    };

    navigate(getLastAvailableLink(location.state.breadcrumbData), {
      replace: true,
      state: {
        ...location.state,
        items: updatedItems,
        breadcrumbData: location.state.breadcrumbData.slice(0, -1),
      },
    });
  }

  function navigateToStructure(kind: "search" | "browse") {
    const currentState = { ...location.state };
    const breadcrumbData = buildBreadcrumb(currentState);
    const crumb = kind === "search" ? ITEMS_STRUCTURE_CRUMBS.search : ITEMS_STRUCTURE_CRUMBS.browse;

    navigate(`${ITEMS_PATH}/structure/${kind}`, {
      replace: true,
      state: {
        ...currentState,
        breadcrumbData: [...breadcrumbData, { name: crumb }],
      },
    });
  }

  return {
    rowChosen,
    editSearchStructure: () => navigateToStructure("search"),
    editBrowseStructure: () => navigateToStructure("browse"),
    selectRow: Boolean(location.state?.breadcrumbData),
  };
}
